import { preferences } from '@apexx/storage';

import {
	DEFAULT_HUB_TEXT_SIZE,
	HUB_TEXT_SIZE_STORAGE_KEY,
	isHubTextSize,
	type HubTextSize,
} from './appTheme';

/** Persists the text size via Preferences (web localStorage / native Capacitor). */
export async function writeHubTextSize(size: HubTextSize): Promise<void> {
	await preferences.setItem(HUB_TEXT_SIZE_STORAGE_KEY, size);
}

/** Loads the preferred text size from Preferences. */
export async function loadHubTextSize(): Promise<HubTextSize> {
	try {
		const stored = await preferences.getItem(HUB_TEXT_SIZE_STORAGE_KEY);
		if (stored && isHubTextSize(stored)) {
			return stored;
		}
	} catch {
		// Ignore storage access errors (private mode, etc.).
	}

	return DEFAULT_HUB_TEXT_SIZE;
}
